import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getCategories = () => api.get("/categories").then(r => r.data);
export const getProducts = (params = {}) => api.get("/products", { params }).then(r => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then(r => r.data);
export const validateCoupon = (code, subtotal) =>
  api.post("/coupon/validate", { code, subtotal }).then(r => r.data);
export const createOrder = (payload) => api.post("/orders", payload).then(r => r.data);
export const submitCustomBouquet = (payload) =>
  api.post("/custom-bouquet", payload).then(r => r.data);

export const WHATSAPP_NUMBER = "919322630051"; // +91 93226 30051
export const SHOP = {
  name: "Sugandhi Flowers",
  owner: "Aditya Bansode",
  address: "Chatrapati Shivaji Maharaj Wyapari Sankul, Near Shivaji Putala, Karad Road, Vita City, Sangli - 415311, Maharashtra",
  city: "Vita, Sangli",
  instagram: "https://www.instagram.com/sugandhiflowermerchant?igsh=dDc4dW1sYTVpejdt&utm_source=qr",
  instagramHandle: "@sugandhiflowermerchant",
  followers: "20K+",
};

export const checkServiceability = (pincode) => api.get("/delivery/serviceability", { params: { pincode } }).then((r) => r.data);
export const getHeroImages = () => api.get("/hero-images").then((r) => r.data);
